import { ListingCate } from '@/page-commons/listingBySlug'

const IMAGIX_PLACEHOLDER_OPTIONS = { ar: '1.25:1', fit: 'crop', h: 10, q: 2, trim: 'auto' }

export const fetchPlaceholderImagesDataURL = async (originalImages: ListingCate['photos']) => {
  const imgixAdditionalOptions = Object.keys(IMAGIX_PLACEHOLDER_OPTIONS).reduce(
    (acc, key) => `${acc}&${key}=${IMAGIX_PLACEHOLDER_OPTIONS[key]}`,
    ''
  )

  return await Promise.all(
    originalImages.map(async (image) => getBase64FromUrl(image.url + '?' + imgixAdditionalOptions))
  )
}

const getBase64FromUrl = async (url: string): Promise<string | ArrayBuffer> => {
  const data = await fetch(url)
  const blob = await data.blob()
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.readAsDataURL(blob)
    reader.onloadend = () => {
      const base64data = reader.result
      resolve(base64data)
    }
  })
}
